module.exports = __webpack_public_path__ + "socicon.a35b65744f557fab5424.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/socicon/font/socicon.svg
// module id = ../../../../socicon/font/socicon.svg
// module chunks = styles